import { Pipe, PipeTransform } from '@angular/core';
import { utcToTimezone } from '@app/helpers/timezone-handler';
import { DEFAULT_TIMEZONE } from '../data/values';


@Pipe({
    name: 'momentTimezonePipe',
    standalone: false
})
  export class MomentTimezonePipe implements PipeTransform {
  
    constructor() {}
  
    transform(utcDate: string | null | undefined, timezone?: string, formatValue?: string): string {
      if (!utcDate?.length) return '';

      // Convert the UTC date to a Moment.js object.
      const momentDate = utcToTimezone(utcDate, (timezone || DEFAULT_TIMEZONE.timezone_identifier));
  
      // Format the date using the Moment.js format() method.
      return formatValue 
        ? momentDate.format(formatValue) 
        : momentDate.format();
    }
  }
  